module.exports = __webpack_public_path__ + "static/media/1POLICY20.1beab6d2.jpg";